import * as React from 'react';
import { __ } from 'react-i18n/lib';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  Button,
  ButtonIcon,
  ButtonStyledStyles,
} from '../../_helpers/form/Button';
import MetaTags from '../../MetaTags/MetaTags';
import { prop } from '../../../utilities';
import { formatShop } from '../../../utilities/shops';
import { Link } from 'react-router';
import Breadcrumbs from '../../Breadcrumbs/Breadcrumbs';
import { StoreDetailBase } from './StoreDetailBase';

const Wrapper = styled.div`
  font-size: ${rem(14)};
`;

const BackButtonWrapper = styled.div`
  display: flex: 
  justify-content:center;
  text-align: center;
  margin-bottom: ${rem(15)};
`;

const BackButton = styled(Button)`
  ${ButtonStyledStyles};
`;

const BackButtonIcon = styled(ButtonIcon)`
  ${({ theme }) => theme.size(24)};
  fill: ${({ theme }) => theme.color.white};
  margin-right: ${rem(10)};
`;

interface StoreDetailProps {
  detail: any;
  breadcrumbItems?: any;
  onClickBack: (id: null) => void;
}

interface StoreDetailState {
  modalVisible: boolean;
  activeIndex: number | null;
  mobileMapVisible: boolean;
}

class StoreDetail extends React.PureComponent<
  StoreDetailProps,
  StoreDetailState
> {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
      activeIndex: null,
      mobileMapVisible: false,
    };
  }

  public onThumbClick = (index) => {
    const isPC = (window && window.innerWidth) > 425;
    if (isPC) {
      this.setState({ modalVisible: true, activeIndex: index });
    }
  };

  public onShowMapClick = () => {
    this.setState({ mobileMapVisible: true });
  };

  public closeModal = () => {
    this.setState({ modalVisible: false });
  };

  public metaHandler = (shopDetail, defaultTitle) => {
    let metaTags: any = {};
    if (shopDetail && shopDetail.content.id !== null) {
      metaTags = prop(shopDetail.content.json_content, 'meta', {
        title: defaultTitle,
      });
    } else {
      metaTags.title = defaultTitle;
    }

    return metaTags;
  };

  public render() {
    let { detail, breadcrumbItems } = this.props;

    detail = formatShop(detail);

    let images = [];
    if (detail && detail.content && detail.content.photogallery) {
      images = detail.content.photogallery.map((item, i) => {
        return item.document_path;
      });
    }
    images.shift();

    const tags = this.metaHandler(
      detail,
      detail ? `Daffer.sk` : 'Daffer.sk - Predajňa',
    );

    return (
      <Wrapper>
        {detail ? (
          <React.Fragment>
            <MetaTags tags={tags} />
            <Breadcrumbs items={breadcrumbItems} />

            <StoreDetailBase detail={detail} />

            <BackButtonWrapper>
              <Link to={'/predajne'}>
                <BackButton className="primary lg">
                  <BackButtonIcon icon="info" />
                  {__('Prehľad predajní')}
                </BackButton>
              </Link>
            </BackButtonWrapper>
          </React.Fragment>
        ) : (
          ''
        )}
      </Wrapper>
    );
  }
}

export default StoreDetail;
